import React from "react";

const IconClose = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">
    <path
      d="M4 4l8 8M12 4l-8 8"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

const IconEdit = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">
    <path
      d="M11.5 2.5l2 2L5 13H3v-2L11.5 2.5z"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);

const IconDelete = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">
    <path
      d="M3 4.5h10M6 4.5V3.5h4v1M5 4.5v8h6v-8"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ICONS = {
  close: IconClose,
  edit: IconEdit,
  delete: IconDelete,
};

export const SiteModalToolbarBtn = ({
  variant = "close",
  onClick,
  title,
  className = "",
}) => {
  const Icon = ICONS[variant] || IconClose;
  const dangerClass = variant === "delete" ? " site-modal-icon-btn--danger" : "";

  return (
    <button
      type="button"
      className={`site-modal-icon-btn${dangerClass}${className ? ` ${className}` : ""}`}
      onClick={onClick}
      title={title}
      aria-label={title}
    >
      <Icon />
    </button>
  );
};
